import { render } from "./TextBody.vue?vue&type=template&id=6810e65e&scoped=true"
import script from "./TextBody.vue?vue&type=script&lang=js"
export * from "./TextBody.vue?vue&type=script&lang=js"

import "./TextBody.vue?vue&type=style&index=0&id=6810e65e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6810e65e"]])

export default __exports__